module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Boletas transferidas"), (_vm.boletas.length > 0) ? _c('span', {
    staticClass: "litle"
  }, [_vm._v(" (" + _vm._s(_vm.boletas.length) + " para generar)")]) : _vm._e()])]), _c('div', {
    staticClass: "center margin-top-10"
  }, [_c('div', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isExporting
    },
    on: {
      "click": _vm.exportarExcel
    }
  }, [_c('span', [_vm._v("Exportar a Excel")])]), _c('div', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isGenerating
    },
    on: {
      "click": _vm.empezarAGenerar
    }
  }, [_c('span', [_vm._v("Generar")])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isGenerating) ? _c('p', {
    staticClass: "margin-top-10"
  }, [_c('vue-circle', {
    ref: "progressCircle",
    attrs: {
      "progress": 0.0,
      "size": 100,
      "insert-mode": "append",
      "fill": _vm.fillCircle
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.boletasGeneradas) + " / " + _vm._s(_vm.cantidadBoletas))])])], 1) : _vm._e()]), _c('p', {
    staticClass: "margin-bottom-10"
  }), (_vm.isFetching) ? _c('spinner', {
    attrs: {
      "size": "60",
      "line-fg-color": "#3a4dc7",
      "line-size": 7
    }
  }) : _c('div', [(_vm.boletas.length === 0) ? _c('div', {
    staticClass: "article message is-info"
  }, [_c('section', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No hay boletas para transferir")])])]) : _vm._e(), _c('div', {
    staticClass: "contenedor-transferidas"
  }, _vm._l((_vm.boletas), function(o) {
    return (_vm.boletas.length > 0) ? _c('div', {
      staticClass: "box"
    }, [_c('boleta-item-transferidos', {
      attrs: {
        "boleta": o
      }
    })], 1) : _vm._e()
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65f65f3c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Boletas_Transferidas.vue
// module id = 819
// module chunks = 0